import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { sessionKit } from './sessionKit';

const WalletContext = createContext(null);

export const WalletProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [restoring, setRestoring] = useState(true);

  useEffect(() => {
    sessionKit.restore()
      .then((restored) => { if (restored) setSession(restored); })
      .catch(() => {})
      .finally(() => setRestoring(false));
  }, []);

  const login = useCallback(async () => {
    const result = await sessionKit.login();
    setSession(result.session);
    return result.session;
  }, []);

  const logout = useCallback(async () => {
    if (session) await sessionKit.logout(session);
    setSession(null);
  }, [session]);

  const actor = session ? String(session.actor) : null;

  return (
    <WalletContext.Provider value={{ session, actor, restoring, login, logout }}>
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => {
  const ctx = useContext(WalletContext);
  if (!ctx) throw new Error('useWallet must be used within WalletProvider');
  return ctx;
};
